import Wrapper from "../../layout/Wrapper";
import NotificationManageComponent from "../../screens/notifications/manage";

import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
	title: "Send Notification",
	description: "",
};

export default function SendNotifications() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<NotificationManageComponent />
		</Wrapper>
	);
}